import http from '@services/http'
import {
  ISignupQuizInfo,
  ISignupQuizSubmit,
  ISignupQuizSkip,
} from '@protocol/signup-quiz'

export default {
  info(data: ISignupQuizInfo.Params): Promise<ISignupQuizInfo.Schema> {
    return http.post('signup-quiz/info', data || {})
  },
  submit(data: ISignupQuizSubmit.Params): Promise<ISignupQuizSubmit.Schema> {
    return http.post('signup-quiz/submit', data || {})
  },
  skip(data: ISignupQuizSkip.Params): Promise<ISignupQuizSkip.Schema> {
    return http.post('signup-quiz/skip', data || {})
  },
}
